import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FakultasTable } from "./components/FakultasTable";
import { JurusanTable } from "./components/JurusanTable";

export default function MasterDataUnitKerjaPage() {
  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">Master Data Unit Kerja</h1>
      </div>
      
      <Tabs defaultValue="fakultas" className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="fakultas">Fakultas</TabsTrigger>
          <TabsTrigger value="jurusan">Jurusan</TabsTrigger>
        </TabsList>
        <TabsContent value="fakultas" className="mt-0">
          <div className="bg-card">
            <FakultasTable />
          </div>
        </TabsContent>
        <TabsContent value="jurusan" className="mt-0">
          <div className="bg-card">
            <JurusanTable />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
